// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Component
import Slider from './Slider/SimpleSlider';

// Images
import pin1 from '../../sass/images/pin1.svg';
import pin2 from '../../sass/images/pin2.svg';

// Hooks
import useSlider from '../hooks/useSlider';
import useLanguage from '../hooks/useLanguage';

function HomeContent({ t }) {
  const { contentSlider } = useSlider();
  const { locale } = useLanguage();
  return (
    <div className="home content_home_div">
      <div className="container_home">
        <Slider contents={contentSlider} />
        <div className="contentHome" align="center">
          <img className="location_left" src={pin1} alt={t('alt:location')} />
          <h1 className="title_home">{t('mission')}</h1>
          <p className="description_home">{t('are')}</p>
          <Link
            className="mobile  register_mobile button_home_register"
            to={`/${locale}/${t('routers:Register')}`}
          >
            {t('register')}
          </Link>
          <img className="location_right" src={pin2} alt={t('alt:location')} />
        </div>
      </div>
    </div>
  );
}

HomeContent.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['home', 'alt', 'routers'])(HomeContent);
